export const MarkAsSentOptions = {
  ASK_VERY_TIME: { label: 'Ask every time', value: 2 },
  NEVER: { label: 'Never', value: 0 },
  ALWAYS: { label: 'Always', value: 1 },
};
